<template>
	<div class="product-list">
		<div class="product-title" v-if="title">
			<h5>{{ title }}</h5>
		</div>
		<search-sort-tab v-if="tabList.length > 0" :tabList="tabList" @sortProduct="sortProduct" />
		<div v-if="isShowProductList" :class="{ 'list-grid': variant === 'card' }">
			<product-list-item
				v-for="(item, index) in list"
				:key="`product_${index}`"
				:item="item"
				:highlightValue="highlightValue"
				:variant="variant"
				:showWish="true"
				@changeWishValue="$emit('changeWishValue')"
				@searchSuccess="searchSuccess"
			/>
		</div>
		<loading v-else keyword="상품 불러오는 중" />
	</div>
</template>

<script>
import SearchSortTab from '@/components/tab/SearchSortTab.vue'
import ProductListItem from '@/components/item/ProductListItem.vue'
import Loading from '@/components/Loading.vue'

export default {
	name: 'ProductList',
	components: {
		SearchSortTab,
		ProductListItem,
		Loading,
	},
	props: {
		list: {
			type: Array,
			default: () => [],
		},
		title: {
			type: String,
			default: '',
		},
		tabList: {
			type: Array,
			default: () => [],
		},
		highlightValue: {
			type: String,
			default: '',
		},
		isShowProductList: {
			type: Boolean,
			default: true,
		},
		// '' (기본) | 'card' (검색 화면: 카드형, 카테고리/판매자 목록 숨김)
		variant: {
			type: String,
			default: '',
		},
	},
	methods: {
		sortProduct(tab) {
			this.$emit('sortProduct', tab)
		},
		searchSuccess(obj) {
			this.$emit('searchSuccess', obj)
		}
	},
}
</script>

<style lang="scss" scoped>
.product-list {
	width: 100%;
	/* 카드형(variant="card"): 한 줄에 2개 */
	.list-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 16px;
		margin-top: 16px;
	}
	.product-title {
		margin-bottom: 20px;
	}
}

/* 모바일: 카드는 한 줄에 하나 */
html.is-mobile .product-list .list-grid {
	grid-template-columns: minmax(0, 1fr);
	gap: 10px;
	margin-top: 12px;
}
</style>
